import { render } from "./DraggableAssistantButton.vue?vue&type=template&id=13401c14&scoped=true"
import script from "./DraggableAssistantButton.vue?vue&type=script&lang=js"
export * from "./DraggableAssistantButton.vue?vue&type=script&lang=js"

import "./DraggableAssistantButton.vue?vue&type=style&index=0&id=13401c14&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13401c14"]])

export default __exports__